module.exports = "<p>{{range|e}}</p>\n";
